/* ************************************************************
                   OVERRIDES FOR 3D SCENE
            Because of course nothing is ever easy...
************************************************************ */

BOLD.options.app.on("option_changed", function (evt) {
  var optionProduct = evt.data.option_product;
  var name = evt.data.option.internalName;
  var value = evt.data.value;

  if (!evt.data.option_product.getOptionByInternalName) {
    //Run our polyfill-setup function if it hasn't run yet.
    if (BOLD.BMS && BOLD.BMS.extendOptions) {
      BOLD.BMS.extendOptions(evt.data.option_product);
    } else {
      return;
    }
  }

  if (name === "Kiosk Type" && value === "Tabletop") {
    return BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Kiosk Type",
      value: "Table Top",
    });
  }

  //for now, have CounterTwist render the 3d Counter view
  if (name === "Kiosk Type" && (value === "CounterTwist" || value === "CounterFixed")) {
    return BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Kiosk Type",
      value: "Counter",
    });
  }
  
  if (
    name === "counterMountBase" ||
    name === "floorMountBase" ||
    name === "tabletopMountBase"
  ) {
    return BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "With Base",
      value: evt.data.value.indexOf("No") == 0 ? false : true,
    });
  }

  if (name === "Color") {
    BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Colour",
      value: value,
    });
  } else if (name === "Face Plate") {
    // Translate the possible faceplate selections to the abbreviation used by the scene
    var lookup = {
      Blank: "BL",
      "Blank (No Holes)": "BL",
      Closed: "BL",
      "Camera + Home": "CH",
      "Camera + Pinhole": "CP",
      "Camera + Pinhole Home": "CP",
      Cam: "CP",
      "Camera Only": "CO",
      "Pinhole Only": "PO",
      "Pinhole Home": "PO",
      "Home Only": "HO",
      "Home Button": "HO",
      "Camera + Home, Sealed": "CH",
    };

    value = value.replace(", Sealed", ""); // Remove this suffix from the value, there's no representation for it in-scene
    value = lookup[value]; // Convert the value to what we might find in the scene

    if (!value) {
      return;
    }
    if (value === "CH") {
      //Apparently some, but not all, of the CH fields are listed in the scene as OP faceplates...
      BOLD.common.eventEmitter.emit("apply_scene_variable", {
        configuratorName: "Face Plate",
        value: "OP",
      });
      BOLD.common.eventEmitter.emit("apply_scene_variable", {
        configuratorName: "Face Plate",
        value: "OP" + " 10.5",
      });
      BOLD.common.eventEmitter.emit("apply_scene_variable", {
        configuratorName: "Face Plate",
        value: "OP" + " 9.7",
      });
      BOLD.common.eventEmitter.emit("apply_scene_variable", {
        configuratorName: "Face Plate",
        value: "OP" + " AIR",
      });
      BOLD.common.eventEmitter.emit("apply_scene_variable", {
        configuratorName: "Face Plate",
        value: "OP" + " SM",
      });
    }
    // And some of the names now have suffixes - the list is pre-filtered by 3Kit, so try all prefixes to see which one is in the scene
    BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Face Plate",
      value: value,
    });
    BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Face Plate",
      value: value + " 10.5",
    });
    BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Face Plate",
      value: value + " 9.7",
    });
    BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Face Plate",
      value: value + " AIR",
    });
    BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "Face Plate",
      value: value + " SM",
    });

    return;
  } else if (name === "Tablet Type") {
    //iPad 5th Gen and iPad 6th Gen aren't in the list of tablets in the scene - correct that
    if (
      value.indexOf("iPad 5th Gen") > -1 ||
      value.indexOf("iPad 6th Gen") > -1 ||
      value.indexOf("iPad 5th & 6th Gen") > -1 ||  //added 20211015-JSL
      value.indexOf("iPad 7th Gen") > -1 ||
      value.indexOf("iPad 8th Gen") > -1 ||
      value.indexOf("iPad 8th & 9th Gen") > -1  //added 20211124-JSL (new 9th gen)
    ) {
      BOLD.common.eventEmitter.emit("apply_scene_variable", {
        configuratorName: "Tablet Type",
        value: 'iPad Pro 9.7"',
      });
    }

    //Name updates, July 2019: Adding mapping from new values to the previous values so that tablet selection is still reflected in the 3D scene
    switch (value) {
      case 'iPad 10th Gen 10.9"':
      case 'iPad Pro & Air 10.5"':
      case 'iPad Pro 11"':
      case 'iPad Pro 11" 1st & 2nd Gen':
      //Dev ED WS
      case 'iPad Pro 11" 3nd Gen':  //note: '3nd' is not right (JSL-20121015)
      //Dev ED WS
      case 'iPad Pro 11" 2nd Gen':
      //removed case 'iPad Pro 11" 3rd Gen (USB C)':
      case 'iPad Pro 11" 3rd Gen':  
      case 'iPad Pro 11" 1st Gen':
      case 'iPad Pro 11" 2nd 3rd & 4th Gen':
      case 'iPad 4th Gen Air 10.9"':
      case 'iPad Air 11"':
      case 'iPad Pro 11" 5th Gen':
      //removed case 'iPad Air 10.9" 4th Gen (USB C)':
      //removed case 'iPad Air 10.9" 4th Gen':
      case 'iPad Air 10.9" 4th & 5th Gen':
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Tablet Type",
          value: 'iPad Pro 10.5"',
        });
        break;
      case 'iPad Air 1 9.7"':
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Tablet Type",
          value: "iPad Air 1",
        });
        break;
      case 'iPad Air 2 9.7"':
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Tablet Type",
          value: "iPad Air 2",
        });
        break;
      case 'Samsung Tab A 10.1" (2016)':
      case 'Samsung Tab A 10.1" (2019)':
      case 'Samsung Tab S6 10.5"':
      case 'Samsung Tab S6 10.5" & Lite 10.4"':        
      case 'Samsung Tab A7 10.4"':
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Tablet Type",
          value: 'Samsung Tab A 10.1"',
        });
        break;
      case '1st & 2nd Gen iPad Pro 12.9"':
      case 'iPad Pro 12.9" 1st & 2nd Gen':
      case 'iPad Pro 12.9" 3rd Gen (USB-C)':
      case 'iPad Pro 12.9" 4th Gen (USB-C)':
      case '3rd Gen (USB C) iPad Pro 12.9"':
      case 'iPad Pro 12.9" 3rd & 4th Gen (USB-C)':
      //removed case 'iPad Pro 12.9" 3rd Gen (USB C)':
      case 'iPad Pro 12.9" 3rd Gen':
      //removed case 'iPad Pro 12.9" 4th Gen (USB C)':
      case 'iPad Pro 12.9" 4th 5th & 6th Gen':
      case 'iPad Pro 12.9" 4th Gen':
      //removed case 'iPad Pro 12.9" 5th Gen (USB C)':
      case 'iPad Pro 12.9" 5th Gen':
      case 'iPad Pro 12.9" 6th Gen':
      case 'iPad Air 13"':
      case 'iPad Pro 13"':    
      case 'iPad Pro 12.9" 4th, 5th & 6th Gen':    
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Tablet Type",
          value: 'iPad Pro 12.9"',
        });
        break;
      //Dev ED WS
      //Dev ED WS

      case 'Samsung Tab S3 9.7"':
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Tablet Type",
          value: "Samsung Tab S3",
        });
        break;
      case "Microsoft Surface Pro":
      case "MS Surface Pro":
      case "MicroSoft Surface Pro 4, 5, 6 & 7":
      case 'Microsoft Surface Pro 5 6 & 7 12.9"':
      case 'Microsoft Surface Pro 5, 6, 7 & 8 12.9"':  
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Tablet Type",
          value: "MicroSoft Surface",
        });
    }

    //Trigger change on the faceplate field so that we're not on the wrong default plate in the scene
    var faceplate =
      evt.data.option_product.getOptionByInternalName("Face Plate");
    setTimeout(function () {
      BOLD.helpers.dom.trigger(
        "change",
        faceplate.DOM.element.querySelector("select,input")
      );
    }, 50);
  } else if (name === "Mount Style") {
    switch (value) {
      case "Pro - Dual Charge":
        BOLD.common.eventEmitter.emit("apply_scene_variable", {
          configuratorName: "Mount Style",
          value: "Pro",
        });
        break;
    }
  } else if (name === "headSKUs") {
    //Trigger change on the faceplate field so that we're not on the wrong default plate in the scene
    var faceplate =
      evt.data.option_product.getOptionByInternalName("Face Plate");
    setTimeout(function () {
      BOLD.helpers.dom.trigger(
        "change",
        faceplate.DOM.element.querySelector("select,input")
      );
    }, 50);
  } else if (name === "brandingPosition") {
    var brandingSkus =
      evt.data.option_product.getOptionByInternalName("brandingSKUs");
    setTimeout(function () {
      BOLD.helpers.dom.trigger(
        "change",
        brandingSkus.DOM.element.querySelector("select,input")
      );
    }, 50);
  }

  /* ************************************************************
  ACCESSORIES: Auto-Select Dual-Charge Option
  ************************************************************ */
  var dualChargeOptions = [
    "Acc-Magtek eDynamo",
    "Acc-eDynamo Enclosure Black",
    "Acc-eDynamo Enclosure White",
    "Acc-RFID-FloBle-White",
    "Acc-RFID-FloBle-Black",
    "Acc-RFID-Serialio-Black",
    "Acc-RFID-Serialio-White",
    "Acc-BBPOS Enclosure-Black",
    "Acc-BBPOS 3X Enclosure-Black",
    "Acc-BBPOS Enclosure-White",
    "Acc-BBPOS 3X Enclosure-White",
    "Stripe M2 Powered Accessory Enclosure",
    "Acc-Stripe M2 Powered Accessory Enclosure-White",
    "Acc-Stripe M2 Powered Accessory Enclosure-Black",
    //"Acc-RFID-WaveID-Black",   //JSL: for "Wave RFID" (Pro mounts), it should not trigger Dual Charge
    //"Acc-RFID-WaveID-White",
  ];
  
  //For testing... (window.optionProduct)
  window.optionProduct = optionProduct;
  
  var powerOption = optionProduct.getOptionByInternalName("Pins");
  var mountStyle = optionProduct.getOptionByInternalName("Mount Style");
  if (powerOption && mountStyle) {
    var styleSelection = mountStyle.getSelectedValues()[0];
    var style = styleSelection ? styleSelection.name : "";
    var isDualCharge = dualChargeOptions.reduce(function (acc, powerOptName) {
      var opt = optionProduct.getOptionByInternalName(powerOptName);
      return (
        acc || (opt && opt.getSelectedValues().length > 0 && style === "Pro")
      );
    }, false);
    var powerVal = isDualCharge ? "Dual Charge" : "Standard Power";

    //new-jsl
    //var isFloorTestPage = $("[name='properties[_HiddenKioskTypeFloor]']").length > 0;
    //var isFloorTestPage = $("[name='properties[_HiddenOptionIncludeProDualMounts]']").length > 0;
    var isPageWithOptionIncludeProDualMounts = $("[name='properties[_HiddenOptionIncludeProDualMounts]']").length > 0;
    
    //if (isFloorTestPage) {
    if (isPageWithOptionIncludeProDualMounts) {
      //console.log("IN FLOOR TEST PAGE");
      //console.log("Special test, force Dual Charge DCP choice for Floor page...TODO: others also");
      //on individual pages, (e.g. Floor, Wall) when MountStyle == 'Pro - Dual Charge', fix the pin setting
      var sty = $("[name='properties[Choose Mount Style]']").val();
      if (sty == 'Pro - Dual Charge') {
          //console.log("SETTING powerVal to PRODUALCHARGE"); 
          powerVal = "Dual Charge";
      }

      /*
      //Hack to reset the DualCharge options after selecting Dual (otherwise, only Pro options of Dual and Standard will show)
      $(document).off("change", "[name='properties[Choose Mount Style]']");
      $(document).on("change", "[name='properties[Choose Mount Style]']", function(){
        var newFloorMountStyle = $(this).val();
        //console.log("YES, you just selected Mount style...., reset input, so all options will still show");

        //if (newFloorMountStyle == 'Pro - Dual Charge') {
        //  var mountStyleZ = optionProduct.getOptionByInternalName("Mount Style");
        //  mountStyleZ.refreshInput();
        //}
        //fix!!
        if (true || newFloorMountStyle != window.floorMountStyle) {
          console.log("!!! newFloorMountStyle and current do not match!!!");

          //$("[name='properties[Choose Mount Style]'] option[value='Basic']").removeAttr("disabled")
          
          //fix!!
          if (true || newFloorMountStyle == 'Smart') {
            console.log("smart, leave alone for this case")
            return false;
          }
        }
        var mountStyleZ = optionProduct.getOptionByInternalName("Mount Style");
        mountStyleZ.refreshInput();
        window.floorMountStyle = $(this).val();  
      }); 
      */
    }
    //new-jsl-end
    
    //window.powerOption = powerOption;
    //console.log("applying pinPowerVal of: "+powerVal);
    powerOption.getValue() !== powerVal && powerOption.receiveValue(powerVal);

    var powerDesc = document.querySelector(
      '.bold_option_displaytext[data-option="Power Option Text"]'
    );

//console.log("isDualCharge:"+isDualCharge+",name:"+name+",powerDesc:"+powerDesc+",powerVal:"+powerVal);
    
    if (powerDesc) {
      isDualCharge
        ? powerDesc.classList.add("active")
        : powerDesc.classList.remove("active");
    }
  }
  if (name.indexOf("BBPOS") > 0) {
    BOLD.common.eventEmitter.emit("apply_scene_variable", {
      configuratorName: "BBPOS",
      value: value != "",
    });
  }

  /* ***************************************************************
  ACCESSORIES: Auto-select "SmartDOCK Power Supply" when smart mount is ordered (9V Power Supply, SKU: 9VPS)
  **************************************************************** */
  //console.log("9vps work, mountStyle"); window.xx9 = mountStyle; window.xx9a = mountStyle.getSelectedValues()[0]; //[Danger:null failure if no mountStyle present, like on handheld page]

  var smartPowerSupplyOption = optionProduct.getOptionByInternalName("SmartPowerSupply");

  if (mountStyle && smartPowerSupplyOption) {
    var styleSelection = mountStyle.getSelectedValues()[0];
    var style = styleSelection ? styleSelection.name : "";

    var smartPowerSupplyDesc = document.querySelector(
      '.bold_option_displaytext[data-option="SmartDOCK Power Supply Text"]'
    );
    
    if (style === "Smart") {
      console.log("9vps, mount is SMART");
      
      var supplyOptionVal = "Include 9V";
      smartPowerSupplyOption.getValue() !== supplyOptionVal && smartPowerSupplyOption.receiveValue(supplyOptionVal);
      
      if (smartPowerSupplyDesc) {
        smartPowerSupplyDesc.classList.add("active");
      }
      
    }
    else {
        if (smartPowerSupplyDesc) {  
          smartPowerSupplyDesc.classList.remove("active");   
        }
    }
  } 

  /* ***************************************************************
  ACCESSORIES: Auto-select enclosure when card reader selected
  **************************************************************** */
  if (name == "Acc-Magtek eDynamo" || name == "Color") {
    var readerOpt = optionProduct.getOptionByInternalName("Acc-Magtek eDynamo");
    if (readerOpt && readerOpt.getSelectedValues()[0]) {
      var blackEnc = optionProduct.getOptionByInternalName(
        "Acc-eDynamo Enclosure Black"
      );
      var whiteEnc = optionProduct.getOptionByInternalName(
        "Acc-eDynamo Enclosure White"
      );

      // Brief timeout to ensure that conditional logic has swapped things around properly
      setTimeout(function () {
        blackEnc && blackEnc.isVisible() && blackEnc.receiveValue("checked");
        whiteEnc && whiteEnc.isVisible() && whiteEnc.receiveValue("checked");
      }, 10);
    }
  }
});

BOLD.common.eventEmitter.on("CLARA.loaded", function () {
  BOLD.common.eventEmitter.emit("apply_scene_variable", {
    configuratorName: "Tablet Type",
    value: 'iPad Pro 9.7"',
  });
  BOLD.common.eventEmitter.emit("apply_scene_variable", {
    configuratorName: "Head Unit",
    value: "H Head Unit",
  });
});


